import { render } from "./recipientsCreate.vue?vue&type=template&id=3ce79b97&scoped=true"
import script from "./recipientsCreate.vue?vue&type=script&lang=js"
export * from "./recipientsCreate.vue?vue&type=script&lang=js"

import "./recipientsCreate.vue?vue&type=style&index=0&id=3ce79b97&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src802653185/src/macra-logistics-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ce79b97"]])

export default __exports__